module.exports = __webpack_public_path__ + "img/yuanyitian.001f5b53.png";